import { render, staticRenderFns } from "./Language3.vue?vue&type=template&id=66d40cab&scoped=true"
import script from "./Language3.vue?vue&type=script&lang=js"
export * from "./Language3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d40cab",
  null
  
)

export default component.exports